import { render } from "./AdminConversationLink.vue?vue&type=template&id=53af06b7"
import script from "./AdminConversationLink.vue?vue&type=script&lang=js"
export * from "./AdminConversationLink.vue?vue&type=script&lang=js"

import "./AdminConversationLink.vue?vue&type=style&index=0&id=53af06b7&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__